import { render } from "./NormalPageContentSection.vue?vue&type=template&id=0ab8bd48&scoped=true"
import script from "./NormalPageContentSection.vue?vue&type=script&lang=js"
export * from "./NormalPageContentSection.vue?vue&type=script&lang=js"

import "./NormalPageContentSection.vue?vue&type=style&index=0&id=0ab8bd48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab8bd48"]])

export default __exports__